import { format } from 'date-fns';
/**
 * Formats a date object to `yyyy-MM-dd`
 * @param date
 */
var formatDateObjectToString = function (date) {
    return format(date, 'MMMM dd, yyyy');
};
export default formatDateObjectToString;
//# sourceMappingURL=formatDateObjectToString.js.map